import {
    FETCH_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK,
    FETCH_CUTTING_WISE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_CUTTING_WISE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_CUTTING_WISE_DATA_FOR_REPORT_FAILURE_DK,
    SET_SUMMARY_GRID_NAME_PROGRAMWISE_REPORT_DK,
    SET_DETAIL_GRID_NAME_PROGRAMWISE_REPORT_DK,
    FETCH_PROGRAMWISE_DETAILED_REPORT_REQUEST_DK,
    FETCH_PROGRAMWISE_DETAILED_REPORT_SUCCESS_DK,
    FETCH_PROGRAMWISE_DETAILED_REPORT_FAILURE_DK,
    FETCH_PROGRAMWISE_CANCELLED_REPORT_REQUEST_DK,
    FETCH_PROGRAMWISE_CANCELLED_REPORT_SUCCESS_DK,
    FETCH_PROGRAMWISE_CANCELLED_REPORT_FAILURE_DK,
    FETCH_PROGRAMWISE_COMPLETED_REPORT_REQUEST_DK,
    FETCH_PROGRAMWISE_COMPLETED_REPORT_SUCCESS_DK,
    FETCH_PROGRAMWISE_COMPLETED_REPORT_FAILURE_DK
} from './programWiseReport.actionType';

export const REPORT_DK = 'reportDK';

let initialState = {
    loading: false,
    reportProgramWiseList: [],
    reportCuttingWiseList: [],
    reportSingleProgramInwardList: [],
    DetailedGrid: [],
    CompletedGrid: [],
    CancelledGrid: [],
    renderGridBtn: 'summaryGrid'
    //renderGridBtn: 'detailGrid',
};

export let reportDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_CUTTING_WISE_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_PROGRAMWISE_DETAILED_REPORT_REQUEST_DK:
        case FETCH_PROGRAMWISE_COMPLETED_REPORT_REQUEST_DK:
        case FETCH_PROGRAMWISE_CANCELLED_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSingleProgramInwardList: updatePayload?.Inward
            };
        case FETCH_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramWiseList: updatePayload
            };
        case FETCH_CUTTING_WISE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportCuttingWiseList: updatePayload
            };
        case FETCH_PROGRAMWISE_DETAILED_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                DetailedGrid: updatePayload?.Detailed
            };
        case FETCH_PROGRAMWISE_COMPLETED_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                CompletedGrid: updatePayload
            };
        case FETCH_PROGRAMWISE_CANCELLED_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                CancelledGrid: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_CUTTING_WISE_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_PROGRAMWISE_DETAILED_REPORT_FAILURE_DK:
        case FETCH_PROGRAMWISE_COMPLETED_REPORT_FAILURE_DK:
        case FETCH_PROGRAMWISE_CANCELLED_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case SET_SUMMARY_GRID_NAME_PROGRAMWISE_REPORT_DK:
            return {
                ...state,
                renderGridBtn: payload
            };
            {
                /*case SET_DETAIL_GRID_NAME_PROGRAMWISE_REPORT_DK:
            return {
                ...state,
                renderGridBtn: payload
            };*/
            }
        default:
            return state;
    }
};
